



















































































































































































































































































































































































































import Vue from 'vue';
import ItemTooltip from '@/components/item/ItemTooltip.vue';
import ItemMaster from '@/classes/item/itemMaster';
import Airbase from '@/classes/airbase/airbase';
import Enemy from '@/classes/enemy/enemy';
import Ship from '@/classes/fleet/ship';
import Const from '@/classes/const';
import Item from '@/classes/item/item';
import SiteSetting from '@/classes/siteSetting';
import ItemStock from '@/classes/item/itemStock';
import SaveData from '@/classes/saveData/saveData';
import ShipValidation from '@/classes/fleet/shipValidation';

type sortItem = { [key: string]: number | { [key: string]: number } };

export default Vue.extend({
  name: 'ItemList',
  components: { ItemTooltip },
  props: {
    handleEquipItem: {
      type: Function,
      required: true,
    },
    handleClose: {
      type: Function,
      required: true,
    },
    handleChangeWidth: {
      type: Function,
      required: true,
    },
  },
  data: () => ({
    itemParent: undefined as undefined | Ship | Airbase | Enemy,
    all: [] as ItemMaster[],
    baseItems: [] as ItemMaster[],
    types: Const.ITEM_TYPES_ALT,
    avoids: Const.AVOID_TYPE,
    type: 0,
    multiLine: true,
    keyword: '',
    isEnemyMode: false,
    isStockOnly: false,
    slot: 0,
    avoidTexts: Const.AVOID_TYPE.map((v) => v.text),
    viewStatus: Const.ITEM_TYPES_ALT[0].viewStatus,
    setting: new SiteSetting(),
    sortKey: '',
    isDesc: false,
    viewItems: [] as { item: Item; count: number }[],
    itemStock: [] as ItemStock[],
    usedItems: [] as Item[],
    confirmDialog: false,
    confirmItem: { item: new Item(), count: 0 },
    headerItems: [
      { text: 'FP', key: 'actualFire' },
      { text: 'TP', key: 'actualTorpedo' },
      { text: 'DB', key: 'actualBomber' },
      { text: 'AA', key: 'antiAir' },
      { text: 'Sortie AA', key: 'actualAntiAir' },
      { text: 'Defense AA', key: 'actualDefenseAntiAir' },
      { text: 'Armor', key: 'armor' },
      { text: 'ASW', key: 'asw' },
      { text: 'ASW', key: 'actualAsw' },
      { text: 'Evasion', key: 'avoid' },
      { text: 'LOS', key: 'actualScout' },
      { text: 'ACC', key: 'actualAccuracy' },
      { text: 'Anti-Bomber', key: 'antiBomber' },
      { text: 'Ship AA', key: 'antiAirWeight' },
      { text: 'Fleet AA', key: 'antiAirBonus' },
      { text: 'Radius', key: 'radius' },
      { text: 'Cost', key: 'cost' },
      { text: 'TP', key: 'tp' },
      { text: 'AA Resist', key: 'avoidId' },
    ],
    enabledTooltip: false,
    tooltipTimer: undefined as undefined | number,
    tooltipItem: new Item(),
    tooltipX: 0,
    tooltipY: 0,
    filterStatus: 'radius',
    filterStatusItems: [] as { text: string; value: string }[],
    filterStatusValue: 0,
    filterStatusValueMenu: false,
  }),
  mounted() {
    const items = this.$store.state.items as ItemMaster[];
    for (let i = 0; i < items.length; i += 1) {
      this.all.push(items[i]);
    }
    this.all.sort((a, b) => a.apiTypeId - b.apiTypeId);
    this.avoidTexts[0] = '';
    this.setting = this.$store.state.siteSetting as SiteSetting;
    this.changeMultiLine(this.setting.isMultiLineForItemList);

    for (let i = 0; i < this.headerItems.length; i += 1) {
      const { text, key } = this.headerItems[i];
      if (text === 'ASW' && this.filterStatusItems.find((v) => v.text === 'ASW')) {
        continue;
      }
      this.filterStatusItems.push({ text, value: key });
    }
  },
  computed: {
    itemListData(): { typeName: string; items: { item: Item; count: number }[] }[] {
      const targetItems = this.viewItems;
      if (this.multiLine) {
        // 種別に応じて分けたい
        const types = Const.ITEM_API_TYPE;
        const resultItems = [];
        for (let i = 0; i < types.length; i += 1) {
          const type = types[i];
          const items = targetItems.filter((v) => v.item.data.apiTypeId === type.id);
          if (items.length) {
            // 存在する艦型を生成
            resultItems.push({ typeName: type.name, items });
          }
        }
        return resultItems;
      }

      // 複数列モードじゃないならなかよし
      return [{ typeName: '', items: targetItems }];
    },
    enabledTypes() {
      const apis = this.baseItems.map((v) => v.apiTypeId);
      const enabledItems = [];
      for (let i = 0; i < this.types.length; i += 1) {
        const d = this.types[i].types;
        if (apis.find((api) => d.includes(api))) {
          enabledItems.push(this.types[i]);
        }
      }
      return enabledItems;
    },
    isShow() {
      return (key: string, items: string[]) => items.includes(key);
    },
    isShowFire(): boolean {
      return this.viewStatus.includes('actualFire');
    },
    isShowTorpedo(): boolean {
      return this.viewStatus.includes('actualTorpedo');
    },
    isShowBomber(): boolean {
      return this.viewStatus.includes('actualBomber');
    },
    isShowAntiAir(): boolean {
      return this.viewStatus.includes('antiAir');
    },
    isShowActAntiAir(): boolean {
      return this.viewStatus.includes('actualAntiAir');
    },
    isShowDefAntiAir(): boolean {
      return this.viewStatus.includes('actualDefenseAntiAir');
    },
    isShowArmor(): boolean {
      return this.viewStatus.includes('armor');
    },
    isShowAsw(): boolean {
      return this.viewStatus.includes('asw');
    },
    isShowActualAsw(): boolean {
      return this.viewStatus.includes('actualAsw');
    },
    isShowAvoid(): boolean {
      return this.viewStatus.includes('avoid');
    },
    isShowScout(): boolean {
      return this.viewStatus.includes('actualScout');
    },
    isShowAccuracy(): boolean {
      return this.viewStatus.includes('actualAccuracy');
    },
    isShowAntiBomber(): boolean {
      return this.viewStatus.includes('antiBomber');
    },
    isShowAntiAirWeight(): boolean {
      return this.viewStatus.includes('antiAirWeight');
    },
    isShowAntiAirBonus(): boolean {
      return this.viewStatus.includes('antiAirBonus');
    },
    isShowRadius(): boolean {
      return this.viewStatus.includes('radius');
    },
    isShowCost(): boolean {
      return this.viewStatus.includes('cost');
    },
    isShowTP(): boolean {
      return this.viewStatus.includes('tp');
    },
    isShowAvoidText(): boolean {
      return this.viewStatus.includes('avoidId');
    },
    isShowAirPower(): boolean {
      return this.viewStatus.includes('airPower');
    },
    isShowDefAirPower(): boolean {
      return this.viewStatus.includes('defenseAirPower');
    },
    formatStatus() {
      return (value: number) => (value ? `${Math.floor(10 * value) / 10}` : '');
    },
  },
  methods: {
    changeType(type = 0): void {
      this.type = type;
      this.filter();
    },
    clickedStockOnly() {
      this.setting.isStockOnlyForItemList = this.isStockOnly;
      this.$store.dispatch('updateSetting', this.setting);
      this.filter();
    },
    initialFilter(parent: Ship | Enemy | Airbase, slotIndex = 0) {
      this.itemParent = parent;
      this.isEnemyMode = false;

      this.filterStatus = 'radius';
      this.filterStatusValue = 0;

      // 現行の所持装備情報を更新
      this.itemStock = this.$store.state.itemStock as ItemStock[];
      this.setting = this.$store.state.siteSetting as SiteSetting;
      this.isStockOnly = this.setting.isStockOnlyForItemList;

      // 一時所持情報データがあるなら
      if (this.$store.getters.getExistsTempStock) {
        this.itemStock = this.$store.state.tempItemStock as ItemStock[];
        this.isStockOnly = true;
      }

      // 搭載数情報を格納
      const isExpand = slotIndex === Const.EXPAND_SLOT_INDEX;
      if (isExpand) {
        this.slot = 0;
      } else {
        this.slot = parent.items[slotIndex] ? parent.items[slotIndex].fullSlot : 0;
      }

      // 現在の計算画面内で配備されている装備を列挙する
      this.usedItems = [];
      const mainData = this.$store.state.mainSaveData as SaveData;
      const manager = mainData.tempData[mainData.tempIndex];
      if (manager) {
        let allItems: Item[] = [];
        // 艦隊データから装備全取得
        for (let i = 0; i < manager.fleetInfo.fleets.length; i += 1) {
          if (i === 4) {
            // 友軍は除外
            continue;
          }

          const { ships } = manager.fleetInfo.fleets[i];
          for (let j = 0; j < ships.length; j += 1) {
            allItems = allItems.concat(ships[j].items.filter((v) => v.data.id > 0));
            if (ships[j].exItem.data.id > 0) allItems.push(ships[j].exItem);
          }
        }

        // 基地航空隊データから装備全取得
        const { airbases } = manager.airbaseInfo;
        for (let i = 0; i < airbases.length; i += 1) {
          allItems = allItems.concat(airbases[i].items.filter((v) => v.data.id > 0));
        }

        this.usedItems = allItems;
      }

      // 装備可能フィルタ
      let types: number[] = [];
      if (parent instanceof Ship && parent.data.id) {
        // 渡された艦娘情報より装備可能種別を取得
        this.baseItems = this.all.filter((item) => ShipValidation.isValidItem(parent.data, item, slotIndex));
        if (this.enabledTypes.length && this.type !== -1 && !this.enabledTypes.find((v) => v.id === this.type)) {
          // カテゴリがおかしかったら最初のカテゴリにする
          this.type = this.enabledTypes[0].id;
        }

        const filterData = this.setting.savedItemListFilter.find((v) => v.parent === 'ship');
        if (filterData && filterData.key) {
          this.filterStatus = filterData.key;
        }
        if (filterData && filterData.value) {
          this.filterStatusValue = filterData.value;
        }

        this.filter();
        return;
      }
      if (parent instanceof Ship) {
        // 空の艦娘 全部盛り
        for (let i = 1; i <= 60; i += 1) {
          if (Const.AB_PLANE_TYPES.includes(i)) {
            continue;
          }
          types.push(i);
        }
      } else if (parent instanceof Airbase) {
        // 基地航空隊 全艦載機装備可能
        types = Const.PLANE_TYPES.concat();
        if (this.type !== -1 && !types.includes(this.type)) {
          // なんか変だったら陸攻を初期位置に
          this.type = 47;
        }
        if (!this.slot) {
          // 搭載数を18に
          this.slot = 18;
        }

        const filterData = this.setting.savedItemListFilter.find((v) => v.parent === 'airbase');
        if (filterData && filterData.key) {
          this.filterStatus = filterData.key;
        }
        if (filterData && filterData.value) {
          this.filterStatusValue = filterData.value;
        }
      } else if (parent instanceof Enemy) {
        // 基本は全装備
        types = Const.ITEM_API_TYPE.map((v) => v.id);
        // 敵装備マスタに存在しない装備カテゴリは抜いておく
        const enemyItems = this.all.filter((v) => v.id > 500);
        types = types.filter((v) => enemyItems.some((x) => x.apiTypeId === v));

        // 敵装備フラグ強制ON
        this.isEnemyMode = true;

        // 初手フィルタ
        if (!types.includes(this.type)) {
          this.type = +types[0];
        }
      }

      if (isExpand) {
        // 補強増設枠フィルタ
        const enabledItems = Const.EXPANDED_ITEM_TYPE;
        types = types.filter((v) => enabledItems.includes(v));
      }

      this.baseItems = this.all.filter((v) => types.includes(v.apiTypeId));
      this.filter();
    },
    changedFilter() {
      const filterData = { parent: 'ship' as 'ship' | 'airbase', key: this.filterStatus, value: this.filterStatusValue };
      if (this.itemParent instanceof Ship) {
        filterData.parent = 'ship';
      } else if (this.itemParent instanceof Airbase) {
        filterData.parent = 'airbase';
      } else {
        this.filter();
        return;
      }

      if (!this.setting.savedItemListFilter) {
        this.filter();
        return;
      }

      const index = this.setting.savedItemListFilter.findIndex((v) => v.parent === filterData.parent);
      if (index >= 0) {
        this.setting.savedItemListFilter[index] = filterData;
        this.$store.dispatch('updateSetting', this.setting);
      }
      this.filter();
    },
    filter() {
      const word = this.keyword;
      let result = this.baseItems.concat();

      if (this.isEnemyMode) {
        // 敵装備
        result = result.filter((v) => v.id > 500);
      } else {
        result = result.filter((v) => v.id < 500);
      }

      // 検索語句あれば最優先 カテゴリ検索を飛ばす
      if (word) {
        result = result.filter((v) => v.id === +word || v.name.indexOf(word) >= 0);
      }

      // カテゴリ検索
      const t = this.types.find((v) => v.id === this.type);
      if (!word && this.type && t) {
        this.viewStatus = t.viewStatus;
        result = result.filter((v) => t.types.includes(v.apiTypeId));
      } else if (!word && this.type === -1) {
        // カテゴリ全て検索
        if (this.itemParent instanceof Ship) {
          // 艦娘 -全て
          this.viewStatus = ['actualFire', 'antiAir', 'actualAccuracy', 'actualScout', 'actualTorpedo', 'asw'];
        } else if (this.itemParent instanceof Airbase) {
          // 基地 -全て
          this.viewStatus = ['actualTorpedo', 'actualBomber', 'actualAntiAir', 'radius', 'airPower', 'defenseAirPower'];
        } else {
          this.viewStatus = ['actualFire', 'actualAntiAir', 'actualAccuracy', 'actualScout', 'avoid', 'armor'];
        }
      }

      let usedItem = this.usedItems.concat();
      const viewItems = [];
      const iniLevels = this.setting.planeInitialLevels;
      const { slot } = this;
      if (!this.isEnemyMode && this.isStockOnly) {
        // 所持装備考慮
        const stock = this.itemStock;
        for (let i = 0; i < result.length; i += 1) {
          const master = result[i];
          const iniLevel = iniLevels.find((v) => v.id === master.apiTypeId);
          const stockData = stock.find((v) => v.id === master.id);
          if (!stockData) {
            // 未所持 出さない
            continue;
          }

          // 熟練度 設定値より
          const level = iniLevel ? iniLevel.level : 0;

          // 改修値★10～0 だけ回す
          for (let remodel = 10; remodel >= 0; remodel -= 1) {
            let count = stockData.num[remodel];
            if (!count) continue;
            const item = new Item({
              master,
              slot,
              remodel,
              level,
            });

            // id 改修値を見て配備済みかどうか判定
            const usedCount = usedItem.filter((v) => v.data.id === master.id && v.remodel === remodel).length;
            // 減らす
            count -= usedCount;
            usedItem = usedItem.filter((v) => v.data.id !== master.id || v.remodel !== remodel);
            viewItems.push({ item, count: Math.max(count, 0) });
          }
        }
      } else {
        // 所持装備考慮なし 愚直に追加
        for (let i = 0; i < result.length; i += 1) {
          const master = result[i];
          const iniLevel = iniLevels.find((v) => v.id === master.apiTypeId);
          const level = iniLevel ? iniLevel.level : 0;
          const item = new Item({
            master,
            slot,
            level,
          });
          viewItems.push({ item, count: 1 });
        }
      }

      this.viewItems = viewItems;

      if (this.filterStatus && this.filterStatusValue) {
        const filterKey = this.filterStatus;
        const value = this.filterStatusValue;
        const isActualFilterKey = filterKey.indexOf('actual') >= 0
          || filterKey === 'tp'
          || filterKey === 'airPower'
          || filterKey === 'defenseAirPower'
          || filterKey === 'antiAirWeight'
          || filterKey === 'antiAirBonus';
        this.viewItems = (this.viewItems as []).filter((v: { item: sortItem }) => {
          if (isActualFilterKey) {
            return v.item[filterKey] >= value;
          }
          return (v.item.data as { [key: string]: number })[filterKey] >= value;
        });
      }

      if (this.sortKey) {
        this.sortItems();
      }
    },
    clickedItem(data: { item: Item; count: number }) {
      this.clearTooltip();
      if (data.count || this.confirmDialog) {
        this.confirmDialog = false;
        this.handleEquipItem(data.item);
      } else {
        this.confirmItem = data;
        this.confirmDialog = true;
      }
    },
    changeMultiLine(isMulti: boolean) {
      this.handleChangeWidth(isMulti ? 1200 : 900);
      this.multiLine = isMulti;

      // 設定書き換え
      this.setting.isMultiLineForItemList = isMulti;
      this.$store.dispatch('updateSetting', this.setting);
    },
    close() {
      this.handleClose();
    },
    toggleSortKey(value: string) {
      if (this.sortKey !== value) {
        // 初回 降順
        this.isDesc = true;
        this.sortKey = value;
      } else if (this.sortKey === value && this.isDesc) {
        // 2回目 昇順
        this.isDesc = false;
      } else if (this.sortKey === value && !this.isDesc) {
        // 3回目 ソート解除
        this.sortKey = '';
        this.filter();
        return;
      }

      this.sortItems();
    },
    sortItems() {
      const key = this.sortKey;
      const desc = this.isDesc ? 1 : -1;
      const isActualValue = key.indexOf('actual') >= 0
        || key === 'tp'
        || key === 'airPower'
        || key === 'defenseAirPower'
        || key === 'antiAirWeight'
        || key === 'antiAirBonus';
      (this.viewItems as []).sort((a: { item: sortItem }, b: { item: sortItem }) => {
        if (isActualValue) {
          return desc * ((b.item[key] as number) - (a.item[key] as number));
        }
        return desc * ((b.item.data as { [key: string]: number })[key] - (a.item.data as { [key: string]: number })[key]);
      });
    },
    bootTooltip(item: Item, e: MouseEvent) {
      const setting = this.$store.state.siteSetting as SiteSetting;
      if (setting.disabledItemTooltip) {
        return;
      }
      const nameDiv = (e.target as HTMLDivElement).getElementsByClassName('item-name')[0] as HTMLDivElement;
      this.tooltipTimer = window.setTimeout(() => {
        const rect = nameDiv.getBoundingClientRect();
        this.tooltipX = this.multiLine ? rect.x + rect.width / 3 : e.clientX;
        this.tooltipY = rect.y + rect.height;
        this.tooltipItem = item;
        this.enabledTooltip = true;
      }, 400);
    },
    clearTooltip() {
      this.enabledTooltip = false;
      window.clearTimeout(this.tooltipTimer);
    },
  },
});
